import LoadingDots from 'components/LoadingDots';
import React from 'react';

const CSS = require('./StripeLoading.module.scss');

function StripeLoading() {
  return (
    <div className={CSS.Container}>
      <LoadingDots />
      <span className={CSS.Message}>
        Loading <mark>Stripe Connect</mark>. <br />
        Please wait a moment.
      </span>
    </div>
  );
}

export default StripeLoading;
